import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const HighConvertingOffersImage = () => {
  const data = useStaticQuery(graphql`
    query {
      HighConvertingOffersImage: file(
        relativePath: { eq: "platform/offers/high-converting-offers.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.HighConvertingOffersImage.childImageSharp.fluid}
      alt="High Converting Offers Image"
    />
  )
}

export default HighConvertingOffersImage
